// Control de tamaño de letra (A- / A+), pensado para usuarios mayores.
// Vive en la barra superior para que SIEMPRE esté a la vista.
import { useEffect, useState } from 'react';
import { getFontScale, setFontScale, applyFontScale, FONT_MIN, FONT_MAX, FONT_STEP } from '../utils/fontScale';

const btn: React.CSSProperties = {
  width: 48, height: 46, border: 'none', background: 'var(--surface)',
  fontWeight: 700, cursor: 'pointer', color: 'var(--ink)',
};

export default function FontSizeControl() {
  const [scale, setScale] = useState(getFontScale());

  // Re-aplicar el zoom guardado al montar: la preferencia persiste entre sesiones.
  useEffect(() => { applyFontScale(); }, []);

  const aplicar = (n: number) => setScale(setFontScale(n));

  return (
    <div title={`Tamaño de letra: ${scale}%`} style={{ display: 'flex', border: '1px solid var(--line-strong)', borderRadius: 10, overflow: 'hidden', flex: 'none' }}>
      <button onClick={() => aplicar(scale - FONT_STEP)} disabled={scale <= FONT_MIN} aria-label="Letra más chica"
        style={{ ...btn, fontSize: 15, opacity: scale <= FONT_MIN ? .35 : 1 }}>A-</button>
      <button onClick={() => aplicar(scale + FONT_STEP)} disabled={scale >= FONT_MAX} aria-label="Letra más grande"
        style={{ ...btn, fontSize: 19, borderLeft: '1px solid var(--line-strong)', opacity: scale >= FONT_MAX ? .35 : 1 }}>A+</button>
    </div>
  );
}
